import { Route, Routes } from "react-router-dom";
// Auth Pages
import { Login } from "../pages/auth/Login";
import { BrandSignUp } from "../pages/brand/auth/SignUp";
import { AuthLayout } from "@/pages/auth/Layout";


export function AuthRoutes() {
  return (
    <Routes>
      {/* Brand Auth Routes */}
      <Route path="/" element={<AuthLayout />}>
        <Route index path="login" element={<Login />} />
        <Route path="signup" element={<BrandSignUp />} />
      </Route>
    </Routes>
  );
}
